import { Option } from '@/components/Select/Select.types';
import { UserRole } from '@/types/user';
import i18next from '@/lang/i18n';

export const COMPANY_SETTINGS_KEY_DISABLED_BANK_ACCOUNTS = 'hide_disabled_banks';
export const COMPANY_SETTINGS_KEY_PAYMENT_INSTRUCTIONS = 'invoice_notice';
export const COMPANY_SETTINGS_KEY_REMINDER_EMAILS_FREQUENCY = 'reminder_emails_frequency';

export const COMPANY_SETTINGS_KEYS = [
  COMPANY_SETTINGS_KEY_DISABLED_BANK_ACCOUNTS,
  COMPANY_SETTINGS_KEY_PAYMENT_INSTRUCTIONS,
  COMPANY_SETTINGS_KEY_REMINDER_EMAILS_FREQUENCY
] as const;

export const REFERRAL_DISCOUNT = 50;

export const AVAILABLE_ROLE_OPTIONS: Option<UserRole>[] = [
  {
    value: UserRole.ADMIN,
    label: i18next.t('admin')
  },
  {
    value: UserRole.ACCOUNTANT,
    label: i18next.t('accountant')
  },
  {
    value: UserRole.HUMAN_RESOURCES,
    label: i18next.t('human_resources')
  },
  {
    value: UserRole.SECRETARY,
    label: i18next.t('secretary')
  }
];

export const READ_ONLY_ROLE_OPTIONS: Option<UserRole>[] = [
  {
    value: UserRole.REPRESENTATIVE,
    label: i18next.t('representative')
  },
  ...AVAILABLE_ROLE_OPTIONS
];

// company statuses
export const COMPANY_STATUS_PENDING_COMPANY_PAYMENT = 'pending_company_payment';
export const COMPANY_STATUS_PENDING_CONTRACT_SIGNATURE = 'pending_company_user_confirmation';
export const COMPANY_STATUS_PENDING_EMAIL_CONFIRMATION = 'pending_email_confirmed';
export const COMPANY_STATUS_PENDING_COMPANY_ARCHIVES = 'pending_company_archives';
export const COMPANY_STATUS_PENDING_MEMBERS_SIGNATURE = 'pending_members_signature';
export const COMPANY_STATUS_PENDING_COMPANY = 'pending_company';
export const COMPANY_STATUS_PENDING_BANK_ACCOUNT = 'pending_bank_account';
export const COMPANY_STATUS_PENDING_VAT_NUMBER = 'pending_vat_number';
export const COMPANY_STATUS_READY = 'ready';
export const COMPANY_STATUS_ON_HOLD = 'onhold';
export const COMPANY_STATUS_STOP = 'stop';
export const COMPANY_STATUS_OFF_BOARD_REQUESTED = 'off_board_requested';
export const COMPANY_STATUS_PENDING_POWER_OF_ATTORNEY = 'pending_power_of_attorney';
export const COMPANY_STATUS_PENDING_REINSTATEMENT = 'pending_reinstatement';

export const ACTIVE_COMPANY_STATUS = [
  COMPANY_STATUS_PENDING_BANK_ACCOUNT,
  COMPANY_STATUS_PENDING_VAT_NUMBER,
  COMPANY_STATUS_READY,
  COMPANY_STATUS_OFF_BOARD_REQUESTED
];

export const COMPANY_ACTIVATION_STATUS = [
  COMPANY_STATUS_PENDING_CONTRACT_SIGNATURE,
  COMPANY_STATUS_PENDING_EMAIL_CONFIRMATION,
  COMPANY_STATUS_PENDING_MEMBERS_SIGNATURE,
  COMPANY_STATUS_PENDING_COMPANY,
  COMPANY_STATUS_PENDING_COMPANY_ARCHIVES,
  COMPANY_STATUS_PENDING_BANK_ACCOUNT,
  COMPANY_STATUS_PENDING_POWER_OF_ATTORNEY
];

export const COMPANY_REGISTRATION_STATUS = [
  COMPANY_STATUS_PENDING_COMPANY_PAYMENT,
  ...COMPANY_ACTIVATION_STATUS
];

export const MANDATE_TYPE_DIRECT_DEBIT = 'directdebit';
export const MANDATE_TYPE_CREDIT_CARD = 'creditcard';
export const MANDATE_TYPE_CARD = 'card';
export const MANDATE_TYPE_SEPA_DEBIT = 'sepa_debit';
